module.exports = __webpack_public_path__ + "static/media/A_goodnest_ui.6cd81dba.png";